import axios from 'crypto-fetch/axios'
import { getChannel, setChannel, isKolCreatorChannel, formatKolCreatorChannel } from '@ms/utils/channel.js'

// ng test 测试 code : B2AFNUZ
/**
 * 解析 sharecode 对应渠道号
 * @param {String} shareCode  booking code
 * 现在渠道优先级：
  1、第三方渠道>kol_name>share_code（wap,pc）> 默认（android, wap为空，ios为Appstore）
 * @returns {String} 返回渠道号
 */
export async function traceBookingCodeKol(shareCode = '', urlChannel = '') {
  // 默认渠道
  const defaultChannel = 'share_code'
  const channel = urlChannel || getChannel()
  // 当前有高优先级渠道号就不调用接口
  if (channel && channel !== defaultChannel && !isKolCreatorChannel(channel)) return
  let kolChannel = defaultChannel
  try {
    const data = await axios.get('/orders/share/creator', {
      params: {
        shareCode
      }
    })
    if (data && data.kolName) {
      // 标识是 kol_name 渠道
      kolChannel = formatKolCreatorChannel(data.kolName)

      if (kolChannel === urlChannel) return
    } else if (channel && kolChannel === defaultChannel) {
      // 拦截 default channel
      return
    }
  } catch (error) {
    console.log(error)
    // 不报错
  }

  setChannel(kolChannel)
  return kolChannel
}
